import styled, { css } from 'styled-components';

import { StyleType } from '~types/common';

export const S = {
  Logo: styled.div<{ hasLogo: boolean; hasBorder?: boolean; logoCss?: StyleType }>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    width: 70px;
    height: 70px;
    ${(props) =>
      props.hasBorder &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.gray400};
      `};

    ${(props) => props.logoCss && props.logoCss};

    ${(props) =>
      props.hasLogo &&
      css`
        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      `};
  `,
};
